import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import { FavoriteWrapper } from 'subsys/favorites';

import TileCard from 'src-sites/bild/section-projects/tile-card';

export default class HorizontalCards extends Component {
  static propTypes = {
    content: PropTypes.arrayOf(PropTypes.shape({}))
  };

  renderCard = (item, key, favData) => (
    <TileCard
      key={key}
      object={item}
      dataMods={{ bild: true }}
      favData={favData}
      noHover
    />
  );

  render() {
    const { content } = this.props;
    if (!content) return null;

    return (
      <FavoriteWrapper project="bild" entity="location">
        {({ data }) => map(content, (item, key) => this.renderCard(item, key, data))}
      </FavoriteWrapper>
    );
  }
}
